export function saveAs(content, filename) {
    if (!content)
        return;
    const url = URL.createObjectURL(content);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
